import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId } from "@ollie-sports/models";

export async function org__client__getOrgs(p: { orgIds: OrgId[] }): Promise<(Org | null)[]> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return await h.Org.getDocs(p.orgIds);
}

// i18n certified - complete
